module.exports = __webpack_public_path__ + "img/brand-icon-dsk.b6cac675.png";